export default function InactiveBusinessIcon() {
  return (
    <svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_54822_136425'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='18'
        height='18'
      >
        <rect width='17.2308' height='17.2308' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_54822_136425)'>
        <path
          d='M6.75164 11.3077H7.82838V5.92307H6.75164V11.3077ZM9.40249 11.3077H10.4792V5.92307H9.40249V11.3077ZM8.61669 15.4359C7.67331 15.4359 6.78658 15.2569 5.95651 14.8989C5.12644 14.5408 4.40443 14.055 3.79046 13.4412C3.17649 12.8275 2.69038 12.1058 2.33213 11.2761C1.97399 10.4464 1.79492 9.5599 1.79492 8.61663C1.79492 7.67325 1.97393 6.78652 2.33195 5.95645C2.68996 5.12638 3.17584 4.40437 3.78956 3.7904C4.40329 3.17643 5.12501 2.69032 5.95472 2.33207C6.78443 1.97393 7.67091 1.79486 8.61418 1.79486C9.55756 1.79486 10.4443 1.97387 11.2744 2.33189C12.1044 2.6899 12.8264 3.17578 13.4404 3.7895C14.0544 4.40323 14.5405 5.12495 14.8987 5.95466C15.2569 6.78437 15.4359 7.67085 15.4359 8.61412C15.4359 9.5575 15.2569 10.4442 14.8989 11.2743C14.5409 12.1044 14.055 12.8264 13.4413 13.4403C12.8276 14.0543 12.1059 14.5404 11.2762 14.8987C10.4464 15.2568 9.55996 15.4359 8.61669 15.4359ZM8.61543 14.359C10.2189 14.359 11.577 13.8026 12.6898 12.6897C13.8026 11.5769 14.359 10.2188 14.359 8.61537C14.359 7.01195 13.8026 5.65384 12.6898 4.54101C11.577 3.42819 10.2189 2.87178 8.61543 2.87178C7.01202 2.87178 5.6539 3.42819 4.54108 4.54101C3.42826 5.65384 2.87185 7.01195 2.87185 8.61537C2.87185 10.2188 3.42826 11.5769 4.54108 12.6897C5.6539 13.8026 7.01202 14.359 8.61543 14.359Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
